/* @flow */
// typecheck: ignore file
import { CONSENT_CHARGE_AMOUNT } from 'constants/ParentalConsentConstants.js';
import React from 'react';
import BoxSelect from 'components/BoxSelect.jsx';
import BoxSelectItem from 'components/BoxSelectItem.jsx';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import Row from 'components/Row.jsx';
import Text from 'components/Text.jsx';
import TitleHeader from 'components/TitleHeader.jsx';

class ParentalConsentOptionsView extends React.Component {
  props: {
    childName?: string,
    onProceed: Function,
    setOption: Function,
  };

  static propTypes = {
    childName: React.PropTypes.string,
    onProceed: React.PropTypes.func.isRequired,
    setOption: React.PropTypes.func.isRequired,
  };

  handleOptionSelect = (option: string) => {
    this.props.setOption(option);
  };

  handleSkip = () => {
    this.props.onProceed();
  };

  render() {
    const { childName } = this.props;

    return (
      <div className="ParentalConsentOptionsView">
        <Container size="medium">
          <TitleHeader
            title={`${childName || 'Your child'} signed up for Remind.`}
            subtext={`
              As part of federal law, we need to confirm that
              ${childName || 'your child'}
              has your permission to use Remind. If
              ${childName || 'your child'}
              doesn’t have permission from a parent or guardian to use Remind, their account will be deleted.
            `}
          />
          <Row size="small">
            <BoxSelect>
              <BoxSelectItem
                glyph="credit-card"
                label="Use a card"
                className="ParentalConsentOptionsView-option--card"
                eventElementName="ParentalConsentOptionsView-option--card"
                action={() => this.handleOptionSelect('card')}>
                Verify your identity with a temporary charge of
                {' '}
                {CONSENT_CHARGE_AMOUNT}
                {' '}
                to your card.
              </BoxSelectItem>
              <BoxSelectItem
                glyph="printer"
                label="Sign a permission form"
                className="ParentalConsentOptionsView-option--signature-file"
                eventElementName="ParentalConsentOptionsView-option--signature-file"
                action={() => this.handleOptionSelect('signature-file')}>
                Print and sign a permission form, then upload it to Remind.
              </BoxSelectItem>
            </BoxSelect>
          </Row>
          <Text align="center" element="div">
            <Button color="eclipse" level="text" data-test="parental-consent-options-view-skip" onClick={() => this.handleSkip()}>
              <Text size="xsmall">Skip for now</Text>
            </Button>
          </Text>
        </Container>
      </div>
    );
  }
}

export default ParentalConsentOptionsView;



// WEBPACK FOOTER //
// ./src/user/components/ParentalConsentOptionsView.jsx